import { styled } from '@mui/material';

const StyledButtonContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '0.9375rem',
  position: 'sticky',
  bottom: '0rem',
  backgroundColor: '#fcfcfc',
  padding: '1rem',
  zIndex: 10,
  borderTop: '0.0625rem solid #ddd9e1',
});

export default StyledButtonContainer;
